import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getOurServiceList } from "../../../Pages/meldi-dham-pages/MeldiDhamCRUD";
import { getTranslatedHeaderData } from "./NewHeaderData";
import { toast } from "react-toastify";

const useHeaderData = () => {
  const { t } = useTranslation();
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    fetchDynamicServices();
  }, [t]); // reload on language change

  const fetchDynamicServices = async () => {
    try {
      const res = await getOurServiceList();

      const serviceItems =
        res?.data?.responseObject
          ?.filter((x) => x.isActive)
          ?.map((x) => ({
            title: x.serviceName,
            link: `/page/service/${x.ourServiceID}`,
          })) || [];

      // Get static translated header
      const baseMenu = getTranslatedHeaderData(t);

      // inject dynamic submenu only for "services" key
      const enriched = baseMenu.map((item) =>
        item.key === "services" ? { ...item, dropdown: serviceItems } : item
      );

      setMenuData(enriched);
    } catch (e) {
      toast.error("Failed to load services");
      console.error("Service Load Error:", e);
    }
  };

  return menuData;
};

export default useHeaderData;
